import type { TransactionItemDetail } from 'models';
import { Avatar, AvatarWrapper, Col, Icon, Row, Text, useFormatPrice } from 'ui';
import type { TransactionViewBasedOnUserDisplayMode } from '..';
import { useGetTransactionItemDate } from '../../../hooks';

type P = {
  displayMode?: TransactionViewBasedOnUserDisplayMode;
  transactionItem: TransactionItemDetail;
};

const TransactionAnonymous = ({ displayMode = 'simple', transactionItem }: P) => {
  const date = useGetTransactionItemDate({ transactionItem });
  const formatPrice = useFormatPrice();

  if (displayMode === 'simple') {
    return (
      <AvatarWrapper
        avatar={{ icon: <Icon color="primary" icon="user-1-line" /> }}
        extra={formatPrice({ value: transactionItem.amount })}
        user={{ name: 'Anonymous' }}
      />
    );
  }

  return (
    <Row align="middle" gutter={['xs', 0]}>
      <Col>
        <Avatar icon={<Icon color="primary" icon="user-1-line" />} />
      </Col>
      <Col flex="auto">
        <Text type="title" weight="medium">
          Anonymous
        </Text>
        <br />
        <Text>{`${formatPrice({ value: transactionItem.amount })} · ${date}`}</Text>
      </Col>
    </Row>
  );
};

export default TransactionAnonymous;
